import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]

import { ref, onMounted, computed, } from 'vue';
import { FooterImagesItem } from '@/view/home/supportScript';
import { useGameStore } from '@/stores/games';


export default /*@__PURE__*/_defineComponent({
  __name: 'copyRightBar',
  props: {
    itemData: {}
  },
  emits: ['openContactPopup'],
  setup(__props: any, { emit: __emit }) {

const gameStore = useGameStore()
const footerImage1 = ref<FooterImagesItem>({
    display: false,
    url: '',
    redirectUrl: ''
})
const footerImage2 = ref<FooterImagesItem>({
    display: false,
    url: '',
    redirectUrl: ''
})
const htmlCopywriteText = ref({
    display: false,
    text: ''
})
const props = __props
const emits = __emit

onMounted(() => {
    footerImage1.value = props.itemData.footerImage1
    footerImage2.value = props.itemData.footerImage2
    htmlCopywriteText.value = props.itemData.htmlCopywriteText
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (footerImage1.value.display)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: footerImage1.value.url,
          alt: "",
          width: "85%"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (footerImage2.value.display)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: footerImage2.value.url,
          alt: "",
          width: "70%",
          style: {"padding-top":"10px"}
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    (htmlCopywriteText.value.display)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          innerHTML: htmlCopywriteText.value.text
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})